import { type SVGProps } from 'react';

interface BlockIconProps extends SVGProps<SVGSVGElement> {}

export default function BlockIcon(props: Readonly<BlockIconProps>) {
  return (
    <svg
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M6.99967 0.333313C3.32367 0.333313 0.333008 3.32398 0.333008 6.99998C0.333008 10.676 3.32367 13.6666 6.99967 13.6666C10.6757 13.6666 13.6663 10.676 13.6663 6.99998C13.6663 3.32398 10.6757 0.333313 6.99967 0.333313ZM1.66634 6.99998C1.66634 5.76931 2.08901 4.63865 2.79167 3.73531L10.2643 11.208C9.33236 11.9372 8.18304 12.3334 6.99967 12.3333C4.05901 12.3333 1.66634 9.94065 1.66634 6.99998ZM11.2077 10.2646L3.73501 2.79198C4.66704 2.06284 5.81632 1.66668 6.99967 1.66665C9.94034 1.66665 12.333 4.05931 12.333 6.99998C12.3327 8.18328 11.9365 9.33247 11.2077 10.2646Z" />
    </svg>
  );
}
